export const CAT_RUNNER_MODE_SINGLE = 'SINGLE';
export const CAT_RUNNER_PRE_ITEM_TYPES = {
  MAGNET: 'MAGNET',
  SHIELD: 'SHIELD',
};

export const CAT_RUNNER_MOCK_RUNTIME = {
  continueSnackCost: 1,
  continueMaxPerRound: 1,
  continueWarmupM: 30,
  startWarmupM: 50,
  maxRunSec: 600,
  baseSpeedPxPerSec: 280,
  maxSpeedPxPerSec: 560,
  speedAccelPerSec: 14,
};

export const createMockCatRunnerStateResponse = () => ({
  result: 'ok',
  balance: 1200,
  snackCount: 2,
  heartsRemaining: 2,
  battleWinToday: false,
  randomRefreshAvailable: true,
  randomRefreshFreeAvailable: true,
  randomRefreshAdRequired: false,
  state: {
    userNo: 1,
    bestDistanceAllTime: 0,
    bestDistanceBiweekly: 0,
    heartUsedToday: 0,
    preItemMagnetArmed: 0,
    preItemShieldArmed: 0,
    battleWinToday: 0,
    randomRefreshUsedToday: 0,
  },
});

const createSeededRandom = (seed) => {
  let state = Math.abs(Number(seed) || 1) % 2147483647;
  if (state === 0) {
    state = 1;
  }

  return () => {
    state = (state * 16807) % 2147483647;
    return (state - 1) / 2147483646;
  };
};

const pickBundleCount = (randomFn) => {
  const roll = Math.floor(randomFn() * 100);
  if (roll < 50) return 1;
  if (roll < 85) return 2;
  return 3;
};

const round = (value, scale = 3) => {
  const factor = 10 ** scale;
  return Math.round(value * factor) / factor;
};

const createMockSpawnManifest = () => {
  const runSeed = 20260708;
  const randomFn = createSeededRandom(runSeed);
  const churuSpawns = [];
  let tSec = 0;

  while (tSec < CAT_RUNNER_MOCK_RUNTIME.maxRunSec) {
    const intervalSec = 0.7 * (0.75 + randomFn() * 0.5);
    tSec += intervalSec;
    churuSpawns.push({
      tSec: round(tSec),
      count: pickBundleCount(randomFn),
    });
  }

  return {
    runSeed,
    maxRunSec: CAT_RUNNER_MOCK_RUNTIME.maxRunSec,
    startWarmupM: CAT_RUNNER_MOCK_RUNTIME.startWarmupM,
    continueWarmupM: CAT_RUNNER_MOCK_RUNTIME.continueWarmupM,
    churuSpawns,
  };
};

export const createMockPlayStartResponse = ({ snackCount, heartsRemaining, preItems = [] }) => ({
  result: 'ok',
  message: 'started',
  snackCount,
  heartsRemaining,
  mode: CAT_RUNNER_MODE_SINGLE,
  roundToken: 'mock-round-token',
  runSeed: 20260708,
  spawnManifest: createMockSpawnManifest(),
  warmupUntilM: CAT_RUNNER_MOCK_RUNTIME.startWarmupM,
  continueRemaining: CAT_RUNNER_MOCK_RUNTIME.continueMaxPerRound,
  countdownRequired: true,
  preItems,
});

export const createMockWeeklyRankingResponse = () => ({
  result: 'ok',
  weekKey: '2026-W28',
  limit: 30,
  entries: [
    { ranking: 1, userNo: 101, nickname: '코코', profileImageUrl: '', bestDistanceM: 971, rewardPoint: 40 },
    { ranking: 2, userNo: 102, nickname: '바질', profileImageUrl: '', bestDistanceM: 840, rewardPoint: 40 },
    { ranking: 3, userNo: 103, nickname: '브로1234', profileImageUrl: '', bestDistanceM: 771, rewardPoint: 40 },
    { ranking: 4, userNo: 104, nickname: '모카', profileImageUrl: '', bestDistanceM: 755, rewardPoint: 40 },
    { ranking: 5, userNo: 105, nickname: '나비', profileImageUrl: '', bestDistanceM: 741, rewardPoint: 40 },
    { ranking: 6, userNo: 106, nickname: '토리', profileImageUrl: '', bestDistanceM: 690, rewardPoint: 40 },
    { ranking: 7, userNo: 107, nickname: '루이', profileImageUrl: '', bestDistanceM: 672, rewardPoint: 40 },
    { ranking: 8, userNo: 108, nickname: '미미', profileImageUrl: '', bestDistanceM: 648, rewardPoint: 40 },
    { ranking: 9, userNo: 109, nickname: '밤비', profileImageUrl: '', bestDistanceM: 621, rewardPoint: 40 },
    { ranking: 10, userNo: 110, nickname: '체리', profileImageUrl: '', bestDistanceM: 600, rewardPoint: 40 },
  ],
});

export const createMockWeeklyRankingMeResponse = () => ({
  result: 'ok',
  weekKey: '2026-W28',
  ranking: 124,
  bestDistanceM: 34,
  nickname: '나',
  profileImageUrl: '',
  rewardPoint: 40,
});

export const getArmedPreItemTypes = (catRunnerState) => {
  if (!catRunnerState?.state) return [];

  const preItemTypes = [];

  if (catRunnerState.state.preItemMagnetArmed) {
    preItemTypes.push(CAT_RUNNER_PRE_ITEM_TYPES.MAGNET);
  }
  if (catRunnerState.state.preItemShieldArmed) {
    preItemTypes.push(CAT_RUNNER_PRE_ITEM_TYPES.SHIELD);
  }

  return preItemTypes;
};

export const armMockPreItem = (catRunnerState, itemType) => {
  if (!catRunnerState?.state) return catRunnerState;

  const nextState = {
    ...catRunnerState,
    state: { ...catRunnerState.state },
  };

  if (itemType === CAT_RUNNER_PRE_ITEM_TYPES.MAGNET) {
    nextState.state.preItemMagnetArmed = 1;
  }
  if (itemType === CAT_RUNNER_PRE_ITEM_TYPES.SHIELD) {
    nextState.state.preItemShieldArmed = 1;
  }

  return nextState;
};

export const consumeMockStartResources = (catRunnerState) => {
  if (!catRunnerState?.state) return catRunnerState;

  const nextHeartsRemaining = Math.max(0, Number(catRunnerState.heartsRemaining ?? 0) - 1);

  return {
    ...catRunnerState,
    heartsRemaining: nextHeartsRemaining,
    state: {
      ...catRunnerState.state,
      heartUsedToday: Number(catRunnerState.state.heartUsedToday ?? 0) + 1,
      preItemMagnetArmed: 0,
      preItemShieldArmed: 0,
    },
  };
};
